// Product-facing pillar definitions. Status is owned by the command-index
// response; a live pillar can have no scored evidence yet.
export const COMMAND_PILLARS = [
  { key: "data_trust", label: "Data Trust" },
  { key: "plan_coverage", label: "Plan Coverage" },
  { key: "review_cadence", label: "Review Cadence" },
];

export function isCommandPillarLive(pillar, indexData) {
  const row = indexData?.pillars?.find((item) => item.key === pillar.key);
  return row?.status === "live";
}

export function getLiveCommandPillars(indexData) {
  return COMMAND_PILLARS.filter((pillar) => isCommandPillarLive(pillar, indexData));
}

export function getUpcomingCommandPillars(indexData) {
  return COMMAND_PILLARS.filter((pillar) => !isCommandPillarLive(pillar, indexData));
}

export function commandPillarCountLabel(indexData) {
  const live = getLiveCommandPillars(indexData).length;
  const excluded = indexData?.pillars?.filter((row) => row.status === "excluded").length ?? 0;
  const upcoming = getUpcomingCommandPillars(indexData).length - excluded;
  return `${live} of ${COMMAND_PILLARS.length} pillars live - ${upcoming} coming soon`
    + (excluded ? ` - ${excluded} excluded` : "");
}